import * as Yup from "yup";
import dayjs from "dayjs";

export const initialValues = {
    forceSave: false,
    movementTypeListId: "MOVEMENT_03_01",
    effectiveDate: dayjs(),
    remark: "",
};

const employeeSalarySalaryModalSchema = Yup.object().shape({
    effectiveDate: Yup.string().required("Please select start date."),
});

export default employeeSalarySalaryModalSchema;